import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "64",
  height: "64",
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {"min-width":"64px","min-height":"64px"}
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill", "stroke"]
const _hoisted_4 = ["fill", "stroke"]
const _hoisted_5 = ["stroke"]
const _hoisted_6 = ["stroke"]
const _hoisted_7 = ["fill", "stroke"]
const _hoisted_8 = ["stroke"]
const _hoisted_9 = ["stroke"]
const _hoisted_10 = ["fill", "stroke"]
const _hoisted_11 = ["fill", "stroke"]
const _hoisted_12 = ["stroke"]
const _hoisted_13 = ["stroke"]
const _hoisted_14 = ["stroke"]
const _hoisted_15 = ["stroke"]
const _hoisted_16 = ["stroke"]
const _hoisted_17 = ["stroke"]
const _hoisted_18 = ["stroke"]
const _hoisted_19 = ["stroke"]
const _hoisted_20 = ["stroke"]
const _hoisted_21 = ["fill", "stroke"]
const _hoisted_22 = ["stroke"]
const _hoisted_23 = ["fill", "stroke"]
const _hoisted_24 = ["fill", "stroke"]
const _hoisted_25 = ["stroke"]
const _hoisted_26 = ["stroke"]
const _hoisted_27 = ["stroke"]
const _hoisted_28 = ["stroke"]
const _hoisted_29 = ["stroke"]
const _hoisted_30 = ["stroke"]


export default /*#__PURE__*/_defineComponent({
  __name: 'CarSmall',
  props: {
    stroke: {
      type: String,
      required: true,
    },
    fill: {
      type: String,
      required: true,
    },
  },
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M0 8C0 3.58172 3.58172 0 8 0H56C60.4183 0 64 3.58172 64 8V56C64 60.4183 60.4183 64 56 64H8C3.58172 64 0 60.4183 0 56V8Z",
      fill: __props.fill
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      d: "M30.0152 47.9131C29.8035 47.9131 29.5919 47.8689 29.3875 47.788L27.1761 46.854C26.2201 46.4274 25.6289 45.1109 25.6289 43.4047C25.6289 41.8896 26.0887 40.323 26.855 39.1831L27.3659 32.8433L52.1654 27.4009L52.3771 33.4611L51.3772 35.1527C51.1656 37.3812 50.0927 39.3816 48.7644 39.9553C48.509 40.0656 48.2681 40.1171 48.0273 40.1171C47.8156 40.1171 47.604 40.073 47.3996 39.9921L45.1883 39.058C44.838 38.9036 44.5314 38.6168 44.2833 38.227L33.3797 42.9487C33.168 45.1771 32.0952 47.1776 30.7669 47.7513C30.5114 47.8616 30.2706 47.9131 30.0298 47.9131H30.0152Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_3),
    _createElementVNode("path", {
      d: "M50.1582 34.5276C50.1582 33.086 49.4722 32.2108 48.6183 32.5786C47.7644 32.9463 47.0784 34.4172 47.0784 35.8587C47.0784 37.3003 47.7644 38.1755 48.6183 37.8077C49.4649 37.44 50.1582 35.9691 50.1582 34.5276Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_4),
    _createElementVNode("path", {
      d: "M47.531 33.8213L49.7059 36.5719",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_5),
    _createElementVNode("path", {
      d: "M49.7059 32.8726L47.531 37.5207",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_6),
    _createElementVNode("path", {
      d: "M32.1536 42.3235C32.1536 40.8819 31.4676 40.0067 30.6137 40.3745C29.7598 40.7422 29.0737 42.2131 29.0737 43.6546C29.0737 45.0962 29.7598 45.9714 30.6137 45.6036C31.4676 45.2359 32.1536 43.765 32.1536 42.3235Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_7),
    _createElementVNode("path", {
      d: "M29.5261 41.6099L31.701 44.3679",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_8),
    _createElementVNode("path", {
      d: "M31.701 40.6685L29.5261 45.3093",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_9),
    _createElementVNode("path", {
      d: "M17.214 25.812C16.7469 24.7823 16.9585 23.5909 17.63 23.1055C18.1773 23.2673 20.4033 24.2675 20.4033 24.2675L20.5128 26.2974L17.2067 25.812H17.214Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_10),
    _createElementVNode("path", {
      d: "M24.0011 46.2802C18.739 45.2432 13.4989 42.647 10.6744 40.6685C9.70378 39.9919 9.33887 39.5286 9.33887 38.646V34.0935C9.33887 32.4975 10.2074 31.5193 11.2875 30.5117C12.3676 29.5041 16.6225 26.6726 16.6225 26.6726L21.0526 20.2887C21.8043 19.2002 22.0597 18.7957 23.2275 18.1926C24.6798 17.4425 26.373 16.7953 27.694 16.2878C29.5405 15.5817 31.6497 15.0963 33.5983 15.7068C34.7952 16.0819 36.9336 16.81 36.9336 16.81L38.0648 16.6335C38.8604 16.4496 40.1303 16.8026 41.1082 16.9865C43.5969 17.4572 51.1871 20.2299 54.0626 22.6128C54.8363 23.26 55.5077 24.0102 55.2888 25.0031L55.2669 25.106V28.9967L55.661 29.8645V31.6664C55.661 32.1592 55.4347 32.6299 55.0479 32.9388L52.1432 35.2481V34.4686C52.1432 31.534 50.7419 29.7616 49.0122 30.5044C47.2826 31.2472 45.8813 34.2406 45.8813 37.1751V38.3812L34.2187 43.4265V42.2204C34.2187 39.2859 32.8174 37.5134 31.0877 38.2562C29.358 39.0064 27.9567 41.9924 27.9567 44.9269V46.1331L27.6794 46.2507C26.5044 46.7582 25.6432 46.5964 23.9938 46.2655L24.0011 46.2802Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_11),
    _createElementVNode("path", {
      d: "M21.3956 19.6929C23.1326 21.2079 32.2773 25.9443 37.9043 26.643L38.8604 27.0623L45.188 24.3116L47.3994 24.7455L48.2897 25.7973L45.4069 29.4599L35.0872 33.9389C35.0872 33.9389 33.8465 33.9021 31.8103 33.5932C27.6867 32.9754 16.7393 28.7685 16.6226 26.6578",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_12),
    _createElementVNode("path", {
      d: "M55.2523 25.0181L53.3183 25.8712L53.2964 28.1806L55.2523 27.2686",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_13),
    _createElementVNode("path", {
      d: "M38.8606 27.0698L35.0874 33.9464V41.132",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_14),
    _createElementVNode("path", {
      d: "M41.1011 26.1802L42.2396 31.0563V38.1462",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_15),
    _createElementVNode("path", {
      d: "M34.219 41.5145L45.8816 36.4692",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_16),
    _createElementVNode("path", {
      d: "M52.0776 33.358L55.6538 30.9678",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_17),
    _createElementVNode("path", {
      d: "M48.2899 31.0121V28.3571L46.874 27.6069",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_18),
    _createElementVNode("path", {
      d: "M54.9681 23.3925C54.9681 23.3925 54.0996 23.6425 52.9027 23.9514C49.8812 21.7671 41.3787 18.3619 36.9268 16.8174",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_19),
    _createElementVNode("path", {
      d: "M46.3779 20.5535C44.6628 21.1198 41.6413 22.245 39.3278 23.3703C38.4739 23.7822 37.5032 23.8557 36.5982 23.5689C32.3287 22.2156 28.446 20.3402 26.2785 19.1855C26.0084 19.0384 26.0084 18.6486 26.2785 18.5015C28.3147 17.3615 31.0369 16.3098 33.2118 15.6626",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_20),
    _createElementVNode("path", {
      d: "M22.0746 40.6172L20.936 40.5069C20.936 40.5069 21.2937 39.4036 22.0381 39.4919C24.826 39.8302 28.227 38.8153 28.5554 38.499C28.0445 39.0653 27.3512 40.779 27.2198 41.1761C27.2198 41.1761 26.4681 41.9851 25.118 41.9851C23.9721 41.9851 22.549 41.463 22.549 41.463L22.0746 40.6172Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_21),
    _createElementVNode("path", {
      d: "M10.1712 31.7031C10.1712 31.7031 9.64576 32.365 10.142 33.2991C10.4851 33.9389 11.4119 34.6818 12.1564 35.329C12.8497 35.9247 12.8132 37.0867 12.8132 37.0867L11.9593 36.3807L11.5871 37.0867C11.5871 37.0867 10.777 36.7043 10.1566 36.0792C9.31004 35.226 9.33923 34.3214 9.33923 34.3214",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_22),
    _createElementVNode("path", {
      d: "M12.813 37.0796C14.0391 38.374 18.0458 40.3156 20.936 40.5069C20.571 41.1835 20.0602 41.7204 19.3814 41.6248C17.046 41.3159 14.1559 39.8155 13.6377 39.0139C13.4844 38.7712 12.9736 38.2416 12.813 37.0796Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_23),
    _createElementVNode("path", {
      d: "M36.7732 31.9388V33.248C37.9774 33.8069 40.6339 33.476 40.9259 33.3656C40.9259 32.2698 40.8821 31.5564 40.3347 31.3578C39.7874 31.1592 37.9336 30.6738 37.9336 30.6738C37.2403 31.0783 36.7659 31.5785 36.7659 31.9315L36.7732 31.9388Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_24),
    _createElementVNode("path", {
      d: "M27.9643 44.3094L27.687 44.4271C26.5119 44.9345 25.6507 44.7727 24.0013 44.4418C18.7393 43.4048 13.4991 40.8086 10.6747 38.8302C9.70402 38.1535 9.33911 37.6902 9.33911 36.8076",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_25),
    _createElementVNode("path", {
      d: "M32.387 32.6226L34.8976 27.1802",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_26),
    _createElementVNode("path", {
      d: "M30.8032 32.3211L33.6714 26.8198",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_27),
    _createElementVNode("path", {
      d: "M31.8106 33.6008C28.249 35.4836 26.9864 36.6824 25.629 37.918C19.7612 37.565 14.521 35.1673 11.2952 32.4902",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_28),
    _createElementVNode("path", {
      d: "M10.9741 34.2997L11.2879 32.4978C12.1345 30.9386 14.1708 29.3647 16.9879 27.4819",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_29),
    _createElementVNode("path", {
      d: "M25.6289 37.9253L24.7458 39.3595",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_30)
  ]))
}
}

})